<template>
    <van-sticky v-if="showTitle">
        <van-nav-bar v-bind="{ ...$props, ...$attrs }" v-on="$listeners"
            :style="{ paddingTop: statusBarHeight, backgroundColor: '#FFFFFF' }" :title="title" :right-text="rightText"
            @click-left="onClickLeft" @click-right="onClickRight" class="reset-nav-bar">
            <template #left>
                <slot name="nav-left" v-if="leftArrow">
                    <a href="javascript:;" name="返回" style="display: flex">
                        <van-icon name="arrow-left" />
                    </a>
                </slot>
            </template>
            <template #right>
                <slot name="nav-right" />
            </template>
        </van-nav-bar>
        <slot name="stickyBox" />
    </van-sticky>
</template>
<script>
export default {
    props: {
        isShowTitle: {
            // 后续如果统一app中不显示头部，可传false 默认true展示，
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "",
        },
        rightText: {
            type: String,
            default: "",
        },
        rightIcon: {
            type: String,
            default: "",
        },
        leftArrow: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === "wechat",
            showTitle: true,
            statusBarHeight: 0,
        };
    },
    created() {
        this.setCompatible();
        if (this.isShowTitle) {
            this.showHead()
        }
    },
    methods: {
        // 是否显示头部组件
        showHead() {
            this.showTitle = this.isShowTitle;
            // 微信不显示头部
            if (this.isWechat) {
                this.showTitle = false;
            }
            // 如果是app 设置白名单 某些路径下显示头部——例如 海纳易学
            // if (this.$isapp) {

            // }
        },
        setCompatible() {
            if (localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight") || 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight") || 0}px`;
            }
        },
        onClickLeft() {
            if (this.$isapp) {
                // 表示为当前点击返回需直接返回到app页面
                // 否则使用h5的返回方式——在给app的页面路径上要加上参数 appWebview=1
                const appWebview = this.$route.query.appWebview;
                if (appWebview) {
                    this.$WDJSBridge.useBack()
                } else {
                    this.$router.go(-1);
                }
            } else {
                this.$router.go(-1);
            }
        },
        onClickRight() {
            this.$emit("onClickRight");
        },
    },
};
</script>
<style lang="less" scoped>
</style>
